import { createContext } from "react";

interface ThemeContextType {
  isDark: boolean | undefined;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);
